<!--企业简介组件-->
<!--置顶begin-->
<meta name="toTop" content="true">
<script type="text/javascript" src="../../../assets/plugins/toTop/toTop.js"></script>
<div class="h36"></div>
<div class="content contentBG fixTarget">
  <div class="rela">
    <div class="w1224 comProfile">
      <div class="floatL comSummaryBox">
        <div class="defaultLogoBig floatL">
          <img [src]="httpService.getImageUrl(companyInfo?.imgUrl)" alt="LOGO"
               *ngIf="companyInfo?.imgUrl != null && companyInfo?.imgUrl != ''"/>
          <img src="../../../assets/images/defaultLogoBig.png" alt="LOGO"
               *ngIf="companyInfo?.imgUrl == null || companyInfo?.imgUrl == ''"/>
        </div>
        <div class="floatL comSummary">
          <div class="comSummaryLT" id="main">
            <!-- 公司名称 -->
            <h4 *ngIf="companyInfo?.name == null">-</h4>
            <h4 [hidden]="companyInfo?.name==null" [innerHTML]="companyInfo?.name | safeHTML"></h4>
            <!--<a *ngIf="companyInfo?.status!=null"  class="btnBlue btnSmall">{{companyInfo?.status}}</a>-->
            <!--<a *ngIf="companyInfo?.status==null"  class="btnBlue btnSmall">-</a>-->

            <!-- 标签 -->
              <span *ngIf="companyInfo?.status!=null" style="cursor: default;" class="btnGreenLine btnSmall">{{companyInfo?.status}}</span>
              <span *ngIf="companyInfo?.status==null" style="cursor: default;" class="btnGreenLine btnSmall">-</span>
              <span *ngIf="!isClaim && userType!='enterprise'" class="btnOrangeLine btnSmall goClaim" (click)="goToClaim()">认领 {{claimCount}}</span>
              <span *ngIf="!isClaim && userType=='enterprise'" style="cursor: default;" class="btnOrangeLine btnSmall">认领&nbsp;{{claimCount}}</span>
              <span *ngIf="isClaim" class="btnOrangeLine btnSmall" style="cursor: default;">已认领{{claimCount}}</span>
          </div>

          <!-- 公司简介内容 -->
          <div class="enterpriseProfileBox">
            <p *ngIf="companyInfo?.creditCode!=null" colspan="2"><span>统一社会信用代码：</span>{{companyInfo?.creditCode}}</p>
            <p *ngIf="companyInfo?.creditCode==null" colspan="2"><span>统一社会信用代码：</span> - </p>

            <p *ngIf="companyInfo?.operName!=null" colspan="2"><span>法定代表人：</span>{{companyInfo?.operName}}</p>
            <p *ngIf="companyInfo?.operName==null" colspan="2"><span>法定代表人：</span> - </p>

            <p *ngIf="companyInfo?.startDate!=null" colspan="2"><span>成立日期：</span>{{companyInfo?.startDate|date:'yyyy-MM-dd'}}</p>
            <p *ngIf="companyInfo?.startDate==null" colspan="2"><span>成立日期：</span> - </p>

            <p>
              <span *ngIf="companyInfo?.webUrl!=null"><span>官网：</span>{{companyInfo?.webUrl}}</span>
              <span *ngIf="companyInfo?.webUrl==null" width="*"><span>官网：</span> - </span>

              <span *ngIf="companyInfo?.email!=null"><span>邮箱：</span>{{companyInfo?.email}}</span>
              <span *ngIf="companyInfo?.email==null" width="*"><span>邮箱：</span> - </span>
            </p>

            <p *ngIf="companyInfo?.address!=null"><span>地址：</span>{{companyInfo?.address}}</p>
            <p *ngIf="companyInfo?.address==null" colspan="2"><span>地址：</span> - </p>

            <p><span>新华信用码：</span>{{xhCode}}</p>
          </div>
        </div>
        <div class="push goWhere">
          <div class="claimBox">
            <nz-popconfirm [nzTitle]="'若您需要申请入驻该企业，可以登录您的个人账户或者直接申请企业入驻'" [nzOkText]="'个人登录'" [nzCancelText]="'企业入驻'"
                           (nzOnConfirm)="rzOpenLogin()" (nzOnCancel)="rzToRegisterEnterp()">
              <a *ngIf="isCertific != '3'&&userType=='enterprise'" style="display: inline-block !important;"
                 class="btnClaim" nz-popconfirm>
                <img src="../../../assets/images/unclaim.png" alt="未认证"/>未入驻
              </a>
            </nz-popconfirm>
            <a *ngIf="isCertific != '3'&&userType!='enterprise'" style="display: inline-block !important;"
               (click)="goToCertific()"
               class="btnClaim">
              <img src="../../../assets/images/unclaim.png" alt="未认证"/>未入驻</a>
            <a *ngIf="isCertific== '3'&& userType!='enterprise'" style="display: inline-block !important;"
               class="btnClaim" (click)="notGoin()">
              <img src="../../../assets/images/claim.png" alt="已认证"/>已入驻</a>
            <a *ngIf="isCertific== '3'&& userType=='enterprise'" style="display: inline-block !important;" class="btnClaim" >
            <img src="../../../assets/images/claim.png" />已入驻</a>
          </div>
        </div>
      </div>
      <div class="floatR busiCardBox">
        <div class="comSummaryBtnBox">
          <a *ngIf="attentionInfo.isAttention=='0'" (click)="concelAttention()" title="取消关注" class="btnBlueLine borTrans btnSmall">
            <i class="fa fa-heart"></i> 已关注</a>
          <a *ngIf="attentionInfo.isAttention=='-1'" (click)="attention()" title="添加关注"
             class="btnBlueLine borTrans btnSmall" style="color: #bbb;">
            <i class="fa fa-heart"></i> 未关注</a>

          <a *ngIf="isSupervise=='0'" (click)="concelSupervise()" title="取消监测"
             class="btnBlueLine borTrans btnSmall">
            <i class="fa fa-video-camera"></i> 已监测</a>
          <a *ngIf="isSupervise!='0'" (click)="gotoSupervise()" title="添加监测" class="btnBlueLine borTrans btnSmall" style="color: #bbb;"><i class="fa fa-video-camera"></i> 未监测</a>
        </div>
        <div class="creatInBox">
          <nz-popconfirm [nzTitle]="'该功能仅向企业用户开放，您可以登录企业账号后创建，或者先申请企业入驻。'" [nzOkText]="'企业登录'" [nzCancelText]="'企业入驻'"
                         (nzOnConfirm)="pmpOpenLogin()" (nzOnCancel)="pmpToRegisterEnterp()">
            <a *ngIf="(isCertific=='1'||isCertific=='2') && userType=='person' " nz-popconfirm>创建企业信用名片</a>
          </nz-popconfirm>

          <nz-popconfirm [nzTitle]="'该企业尚未进行企业入驻，暂时不能进行创建企业名片，您可以登录个人账号或者直接申请企业入驻。'" [nzOkText]="'个人登录'"
                         [nzCancelText]="'企业入驻'"
                         (nzOnConfirm)="mpOpenLogin()" (nzOnCancel)="mpToRegisterEnterp()">
            <a *ngIf="(isCertific=='1'||isCertific=='2') && userType=='enterprise' " nz-popconfirm>创建企业信用名片</a>
          </nz-popconfirm>

          <a *ngIf="(isCertific=='1'||isCertific=='2') && userType!='person' && userType !='enterprise'"
             (click)="creditCard()" class="btnCreatIn">创建企业信用名片</a>
          <a *ngIf="isCertific=='3'&&hasCard" [routerLink]="['/BusinessCardPreview/EnterpPreview']"
             [queryParams]="{companyId:companyId,type:'4'}" target="_blank" class="btnCreatIn">查看企业信用名片</a>
          <a *ngIf="isCertific=='3'&&!hasCard&&!isSelf" class="btnCreatIn">尚无企业信用名片</a>
          <a *ngIf="isCertific=='3'&&!hasCard&&isSelf" (click)="creditCard()" class="btnCreatIn">创建企业信用名片</a>
        </div>
        <img id="imageQRCode" class="busiCardEWM" style="display: none;" width="110" height="110"
             alt="扫一扫" onclick="return false;"/>
        <div class="bdsharebuttonbox"><a href="javascript:void(0);" class="bds_more" data-cmd="more"></a><a
          href="javascript:void(0);" class="bds_qzone"
          data-cmd="qzone"
          title="分享到QQ空间"></a><a
          href="javascript:void(0);" class="bds_tsina" data-cmd="tsina" title="分享到新浪微博"></a><a
          href="javascript:void(0);" class="bds_tqq" data-cmd="tqq"
          title="分享到腾讯微博"></a><a href="javascript:void(0);"
                                 class="bds_renren"
                                 data-cmd="renren"
                                 title="分享到人人网"></a><a
          href="javascript:void(0);" class="bds_weixin" data-cmd="weixin" title="分享到微信"></a></div>
        <script>window._bd_share_config = {
          "common": {
            "bdSnsKey": {},
            "bdText": "",
            "bdMini": "2",
            "bdPic": "",
            "bdStyle": "0",
            "bdSize": "16"
          }, "share": {}
        };
        with (document) 0[(getElementsByTagName('head')[0] || body).appendChild(createElement('script')).src = 'http://bdimg.share.baidu.com/static/api/js/share.js?v=89860593.js?cdnversion=' + ~(-new Date() / 36e5)];</script>
      </div>
      <div class="push"></div>
    </div>

    <div class="Tab1" id="tab1">
      <div class="w1224 rela">
        <div class="downLoadRpt">
          <a (click)="creditReportDownload()">
            <span>信用报告下载&nbsp;&nbsp;<i class="fa fa-download"></i></span>
          </a>
        </div>
      </div>
      <ul class="w1224 Tab1tit" id="tabUL">
        <li class="TabActive">
          <a [routerLink]="['./enterpBasicArchives']" [queryParams]="{companyId: companyId}">企业档案</a>
        </li>
        <li>
          <a [routerLink]="['./enterAtlas']" [queryParams]="{companyId: companyId}">企业图谱</a>
        </li>
        <li *ngIf="userType=='enterprise'||userType=='person'">
          <a [routerLink]="['./enterpPortrait']" [queryParams]="{companyId: companyId,companyName:companyName}">信用评价</a>
        </li>
        <li *ngIf="userType!='enterprise'&&userType!='person'">
          <a (click)="openLoginEnterp()">信用评价</a>
        </li>

        <li *ngIf="userType=='enterprise'||userType=='person'">
          <a [routerLink]="['./monitor']"
             [queryParams]="{companyId: companyId,type:1}">企业监测</a>
        </li>
        <li *ngIf="userType!='enterprise'&&userType!='person'">
          <a (click)="openLoginEnterp()">企业监测</a>
        </li>

      </ul>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>


<!--名片协议弹出，目前协议内容不确定，确定后放开次功能-->
<!--<nz-modal [nzVisible]="isVisible" [nzTitle]="'创建企业名片协议'" [nzContent]="modalContent" [nzFooter]="modalFooter" (nzOnCancel)="handleCancel()">-->
<!--<ng-template #modalContent>-->
<!--<div class="modal-body" style="height:300px">-->
<!--<div class="LoginBox law-box">-->
<!--<div class="law-in-box" style="overflow-y:scroll;height: 240px;">-->
<!--<p>-->
<!--<br/>-->
<!--</p>-->
<!--<p>-->
<!--声明及信息使用授权书-->
<!--</p>-->
<!--<p>-->
<!--<span>&nbsp;</span>-->
<!--</p>-->
<!--<p>-->
<!--新华中经信用管理有限公司：-->
<!--</p>-->
<!--<p>-->
<!--<span>&nbsp;</span>-->
<!--</p>-->
<!--<p>-->
<!--本单位承诺，本单位在新华信用大数据平台网站提供的所有信息及资料，均是真实、准确、完整、最新的信息，无重大遗漏。如本单位提供的信息或资料存在虚假、不准确、或存在重大遗漏，由此所导致的不利后果由本单位承担，包括但不限于赔偿贵司或第三方因此所遭受的任何损失、费用或责任。-->
<!--</p>-->
<!--<p>-->
<!--<span>&nbsp;</span>-->
<!--</p>-->
<!--<p>-->
<!--本单位授权贵司在下列情形下，使用本单位在新华信用大数据平台网站上传的全部信息，以及根据《新华信用企业及机构用户服务协议》新华信用大数据平台网站已采集加工的行业协会、政府有关部门、人民法院等公开发布或可供公共查询的关于本单位的信息。同意贵司将最终形成的信用报告进行归档、保存和分析。-->
<!--</p>-->
<!--<p class="MsoListParagraph" style="margin-left:48px">-->
<!--<span>一、<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;font-family: &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>本单位申请出具企业信用报告（标准版或深度版）的，-->
<!--</p>-->
<!--<p class="MsoListParagraph" style="margin-left:48px">-->
<!--<span>二、<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;font-family: &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>本单位授权第三方查询本单位非公开信用信息，或申请获取本单位的企业信用报告（标准版或深度版）的，-->
<!--</p>-->
<!--<p class="MsoListParagraph" style="margin-left:48px">-->
<!--<span>三、<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;font-family: &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>处理本单位异议的，-->
<!--</p>-->
<!--<p class="MsoListParagraph" style="margin-left:48px">-->
<!--<span>四、<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;font-family: &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>根据相关法律法规或政府主管部门的要求提供本单位信息的，或-->
<!--</p>-->
<!--<p class="MsoListParagraph" style="margin-left:48px">-->
<!--<span>五、<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;font-family: &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>涉及本单位的其他征信事项的。-->
<!--</p>-->
<!--<p>-->
<!--<span>&nbsp;</span>-->
<!--</p>-->
<!--<p>-->
<!--本授权书自本单位在新华信用网站的账户提交授权书之日起生效，有效期至本单位注销在在新华信用网站的账户之日止。-->
<!--</p>-->
<!--<p>-->
<!--<span>&nbsp;</span>-->
<!--</p>-->
<!--<p>-->
<!--本单位知悉并完全理解上述授权，特此授权。-->
<!--</p>-->
<!--<p>-->
<!--<br/>-->
<!--</p>-->

<!--</div>-->
<!--&lt;!&ndash;<div class="xy"><input type="checkbox" (click)="checkProtocol()">已阅读并接受<span style=" color:blue" >用户协议</span></div>&ndash;&gt;-->
<!--</div>-->
<!--</div>-->
<!--</ng-template>-->
<!--<ng-template #modalFooter>-->
<!--<div style="text-align: center;">-->
<!--<button nz-button [nzType]="'primary'" [nzSize]="'large'" (click)="checkProtocol()">阅读并接受</button>-->
<!--<button nz-button [nzType]="'default'" [nzSize]="'large'" (click)="handleCancel($event)">返 回</button>-->
<!--</div>-->
<!--</ng-template>-->
<!--</nz-modal>-->





// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/enterp-introduction/enterp-introduction.component.html